export function formatText(text?: string, capitalizeFirstOnly?: boolean): string {
	if (!text) return '';

	const minorWords = ['de', 'da', 'das', 'do', 'dos', 'e', 'nas', 'no'];

	const words = text
		.trim()
		.toLowerCase()
		.split(/\s+/)
		.map((word, index) => {
			if (index === 0 || !minorWords.includes(word)) {
				return word.charAt(0).toUpperCase() + word.slice(1);
			}
			return word;
		});

	if (capitalizeFirstOnly) {
		words[0] = words[0].charAt(0).toUpperCase() + words[0].substring(1);
		return words.join(' ');
	}

	return words.join(' ');
}
